import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container } from 'reactstrap';
import { withRouter } from "react-router";

import Footer from '../layoutItems/footer';

class LoginLayout extends Component {
    mainStyle = () => {
        let stl = {};
        if (this.props.layout.topMenuHeight && this.props.layout.footer) {
            stl.minHeight = `100vh`;
            stl.width = "100%";
        }
        return stl;
    };

    render() { 
        const Component = this.props.component;
        return (
            <div className="d-flex all-father" style={{width: "100%"}}>
                <main role="main" className="flex-shrink-0" style={this.mainStyle()}>
                    <Container style={{ paddingLeft: "0", paddingRight: "0" }} fluid={true}>
                        <Component {...this.props.children} />
                        <Footer public={true} />
                    </Container>
                </main>
            </div>
        );
    }
}

export default connect(
    state => { return { ...state.appContext, ...state.report, layout: state.layout }; }
)(withRouter(LoginLayout));